// 교육부 석차등급 산출 (순수 함수).
// 누적인원 = round(수강자수 × 누적비율), 동점이 등급 경계에 걸리면 중간석차백분율.

export const RATIOS_5 = [10, 34, 66, 90, 100];
export const RATIOS_9 = [4, 11, 23, 40, 60, 77, 89, 96, 100];

const EMPTY_STATS = { rank: "", cumulativePercent: "", rankClass: "" };

function isValidNumber(val) {
  if (val === "" || val === null || val === undefined) return false;
  const num = Number(val);
  return !Number.isNaN(num);
}

function toNumericGrades(grades) {
  if (!grades || grades.length === 0) return [];
  return grades.filter(isValidNumber).map((grade) => Number(grade));
}

export function cumulativeHeadcounts(n, percents) {
  return percents.map((p) => Math.round((n * p) / 100));
}

function classForRank(rank, cutoffs) {
  for (let i = 0; i < cutoffs.length; i++) {
    if (rank <= cutoffs[i]) return i + 1;
  }
  return cutoffs.length;
}

function classForMidPercent(midPercent, percents) {
  for (let i = 0; i < percents.length; i++) {
    if (midPercent <= percents[i]) return i + 1;
  }
  return percents.length;
}

export function getCompetitionRank(grades, targetGrade) {
  const numericGrades = toNumericGrades(grades);
  if (numericGrades.length === 0) return "";

  if (!isValidNumber(targetGrade)) return "";
  const numericTarget = Number(targetGrade);

  const rank = 1 + numericGrades.filter((grade) => grade > numericTarget).length;
  const tieCount = numericGrades.filter(
    (grade) => grade === numericTarget,
  ).length;
  if (tieCount === 0) return "";

  return rank;
}

export function getRankCumulativePercent(rank, n) {
  if (rank === "" || rank == null || !n) return "";
  const numericRank = Number(rank);
  const numericN = Number(n);
  if (Number.isNaN(numericRank) || Number.isNaN(numericN) || numericN <= 0) {
    return "";
  }
  return `${((numericRank / numericN) * 100).toFixed(1)}%`;
}

// 유효 점수 풀에서 targetGrade의 석차등급. 없거나 불가하면 "".
export function getMoeRankClass(grades, targetGrade, percents) {
  if (!percents || percents.length === 0) return "";

  const numericGrades = toNumericGrades(grades);
  const n = numericGrades.length;
  if (n === 0) return "";

  if (!isValidNumber(targetGrade)) return "";
  const numericTarget = Number(targetGrade);

  const rank = 1 + numericGrades.filter((grade) => grade > numericTarget).length;
  const tieCount = numericGrades.filter(
    (grade) => grade === numericTarget,
  ).length;
  if (tieCount === 0) return "";

  const cutoffs = cumulativeHeadcounts(n, percents);
  const groupStart = rank;
  const groupEnd = rank + tieCount - 1;
  const classStart = classForRank(groupStart, cutoffs);
  const classEnd = classForRank(groupEnd, cutoffs);

  if (classStart === classEnd) return classStart;

  const midRank = rank + (tieCount - 1) / 2;
  const midPercent = (midRank / n) * 100;
  return classForMidPercent(midPercent, percents);
}

export function buildRankStatsMap(entries, percents) {
  const map = {};
  if (!entries || entries.length === 0) return map;

  const grades = entries.map((entry) => entry.grade);
  const n = toNumericGrades(grades).length;

  entries.forEach((entry) => {
    if (!isValidNumber(entry.grade)) {
      map[entry.id] = EMPTY_STATS;
      return;
    }

    const rank = getCompetitionRank(grades, entry.grade);
    map[entry.id] = {
      rank,
      cumulativePercent: getRankCumulativePercent(rank, n),
      rankClass: getMoeRankClass(grades, entry.grade, percents),
    };
  });

  return map;
}
